import {Injectable} from '@angular/core';
import {NotificationModel} from '../api/models';
import {NotificationsService} from '../api/services';

@Injectable()
export class DownloadsService {

  constructor(private apiNotificationsService: NotificationsService,
  ) {

  }

  async getExportFileList(): Promise<NotificationModel[]> {

    const list = await this.apiNotificationsService.notificationGetExportNotifications().toPromise();

    return  list;
  }
}
